import { Reveal } from "@/components/okaia/Reveal";

const PROFILES = [
  { n: "01", title: "Porteurs de projet", text: "Préciser une idée et choisir les premières démarches." },
  { n: "02", title: "Créateurs d'entreprise", text: "Organiser les prochaines étapes du lancement." },
  { n: "03", title: "Entrepreneurs et indépendants", text: "Clarifier l'offre, les priorités ou le développement commercial." },
  { n: "04", title: "Personnes en reconversion", text: "Explorer un projet d'activité et les compétences nécessaires." },
  { n: "05", title: "Dirigeants de petites structures", text: "Prendre du recul sur une difficulté ou une priorité de développement." },
];

export const Profiles = () => (
  <section id="diagnostic" data-testid="section-profils" style={{ scrollMarginTop: "90px" }} className="bg-[#F9F8F6] py-16 md:py-24">
    <div className="mx-auto max-w-[1400px] px-6 md:px-12">
      <Reveal>
        <p className="okaia-overline mb-6 text-[#B39265]">Le Diagnostic Business en détail</p>
        <h2 className="max-w-2xl font-serif-display text-4xl leading-[1.1] tracking-tight text-[#0B2215] md:text-5xl">
          À qui s'adresse le Diagnostic Business&nbsp;?
        </h2>
      </Reveal>
      <div className="mt-12 grid gap-px border border-[#0B2215]/15 bg-[#0B2215]/15 sm:grid-cols-2 lg:grid-cols-5">
        {PROFILES.map((p, i) => (
          <Reveal key={p.n} delay={i * 0.08} className="group bg-[#F9F8F6] transition-colors duration-500 hover:bg-[#0B2215]">
            <div data-testid={`profile-card-${p.n}`} className="flex h-full flex-col justify-between p-7 md:p-8">
              <span className="font-serif-display text-2xl italic text-[#C8A97E]">{p.n}</span>
              <div className="mt-10">
                <h3 className="font-serif-display text-lg tracking-tight text-[#0B2215] transition-colors duration-500 group-hover:text-[#F9F8F6] md:text-xl">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm font-light leading-relaxed text-[#4A5A52] transition-colors duration-500 group-hover:text-[#A3B1AA]">
                  {p.text}
                </p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <p data-testid="profiles-note" className="mt-6 text-sm font-light italic text-[#4A5A52]">
          Le Diagnostic Business ne remplace pas une expertise juridique ou comptable, ni un
          bilan de compétences.
        </p>
      </Reveal>
    </div>
  </section>
);
